import Main from '../../components/layout/Main';
import PublicProfile from './PublicProfile';

export default function Profile() {
  return (
    <Main main={<PublicProfile />} contentLeft={null} contentRight={null} />
  );
}
